import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { tokens } from '@equinor/eds-tokens';

var colors = tokens.colors,
  comfortable = tokens.spacings.comfortable,
  typography = tokens.typography;
var helperText = {
  background: colors.ui.background__light.hex,
  typography: _objectSpread(_objectSpread({}, typography.input.helper), {}, {
    color: colors.text.static_icons__tertiary.rgba
  }),
  spacings: {
    comfortable: {
      left: comfortable.small,
      right: comfortable.small,
      top: comfortable.small,
      bottom: '6px'
    },
    compact: {
      left: comfortable.small,
      right: comfortable.small,
      top: comfortable.xx_small,
      bottom: '6px'
    }
  }
};

export { helperText };
